import { Component, OnInit } from '@angular/core';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { assetUrl } from 'src/single-spa/asset-url';

@Component({
  selector: 'app-saving-tips',
  templateUrl: './saving-tips.component.html',
  styleUrls: ['./saving-tips.component.scss']
})
export class SavingTipsComponent implements OnInit {
  public disableButton = true;
  assetsUrl = environment.assetsUrl;
  constructor(private router: Router) {}
  assetUrlMFE = assetUrl('');
  ngOnInit(): void {
    setTimeout(() => {
      this.disableButton = false;
    }, 9000);
  }

  public redirect() {
    this.router.navigate([routesData.PRODUCT_SUMMARY.redirectPath]);
  }
}
